import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section 
      className="relative py-24 px-4"
      style={{
        backgroundImage: "url('/lovable-uploads/15bd97e5-06d5-450e-b0a9-427be5e07f22.png')",
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        backgroundColor: '#f8fafc', // Light background color to ensure text readability
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 to-blue-800/95" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold text-white mb-6">
            Transform Your Online Store
          </h1>
          <p className="text-xl text-gray-200 mb-8">
            Build a powerful eCommerce presence with our comprehensive solutions. 
            Leveraging custom storefronts, seamless payment integration, and AI-powered Agents, 
            we create exceptional shopping experiences that drive conversions, enhance customer 
            satisfaction, and scale your online business.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50">
                Get Started
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            <Link to="/case-studies">
              <Button 
                size="lg" 
                variant="outline" 
                className="border-white text-white bg-transparent hover:bg-white/10"
              >
                View Case Studies
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};